<div class="flex items-center space-x-2">
  @if (options.length) {
    <p-inputgroup class="w-full md:!w-56">
      <p-inputgroup-addon>
        {{ options.length }}
      </p-inputgroup-addon>
      <p-select
        [options]="options"
        [(ngModel)]="selectedAsset"
        optionLabel="name"
        placeholder="Select Audio">
        <ng-template let-option #item>
          <div class="w-full flex items-center justify-between space-x-2">
            <span>{{ option.name }}</span>
          </div>
        </ng-template>
      </p-select>
    </p-inputgroup>
  }
  @if (selectedAsset) {
    <app-audio-asset [asset]="selectedAsset.control" />
  }
</div>
